import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import Bus from 'EurestoClass/Bus'
import Utils from 'EurestoFonction/Utils'
import React from 'react'

const project = require('EurestoConfig/project.config')

const axios = require('axios')
const CancelToken = axios.CancelToken

//const source = CancelToken.source()

class Search extends React.Component {
    constructor(props) {
        super(props)
        const saveSearch = !this.props.unsave && localStorage.getItem('search_' + props.search) && JSON.parse(localStorage.getItem('search_' + props.search))
        const saveSort = !this.props.unsave && localStorage.getItem('sort_' + props.sort) && JSON.parse(localStorage.getItem('sort_' + props.sort))
        this.state = {
            data: props.data || [],
            defaultSearch: props.defaultSearch && EurestoClone(props.defaultSearch),
            type: props.type,
            action: props.action,
            search: props.defaultSearchPriority && props.defaultSearch && EurestoClone(props.defaultSearch) || saveSearch && Object.keys(saveSearch).length > 0 && saveSearch
                || props.defaultSearch && EurestoClone(props.defaultSearch)
                || {},
            sort: props.defaultSortPriority && props.defaultSort && EurestoClone(props.defaultSort) || saveSort && Object.keys(saveSort).length > 0 && saveSort
                || props.defaultSort && EurestoClone(props.defaultSort)
                || [],
            dedupe: props.dedupe || [],
            loading: false,
            typingTimeout: 0,
            dataSize: 0,
            offset: 0,
            scrollBodyPosition: 0,
            filtre: undefined,
            keyRAZ: Utils.getRandomNumber(),
            busGUID: Utils.uuidv4()
        }
    }
    key = Utils.getRandomNumber()
    cancelToken = {}

    componentWillUnmount() {
        Bus.$off('infinityScroll_search_' + this.props.search, this.state.busGUID)
        Bus.$off('sorted_search_' + this.props.search, this.state.busGUID)
        Bus.$off('forced_search_' + this.props.search, this.state.busGUID)
        Bus.$off('forced_research_' + this.props.search, this.state.busGUID)
    }

    componentDidMount() {
        this.search(this.state.search)
        Bus.$on('infinityScroll_search_' + this.props.search, () => {
            this.key = Utils.getRandomNumber()
            this.cancelToken = {
                ...this.cancelToken || {},
                [this.key]: CancelToken.source()
            }
            this.setState({
                typingTimeout: 0,
            }, () => this.callSearch(this.key, { all: true }))
        }, this.state.busGUID)
        Bus.$on('sorted_search_' + this.props.search, (sort) => {
            !this.props.unsave && localStorage.setItem('sort_' + this.props.search, JSON.stringify(sort))
            if (!(this.state.data.length >= this.state.dataSize)) {
                this.setState({
                    sort: sort
                }, _ => this.search(this.state.search))
            }
        }, this.state.busGUID)
        Bus.$on('forced_search_' + this.props.search, (search) => {
            this.search(search)
        }, this.state.busGUID)
        Bus.$on('forced_research_' + this.props.search, () => {
            this.search(this.state.search)
        }, this.state.busGUID)
    }

    search = async (search, options = {}) => {
        !this.props.unsave && localStorage.setItem('search_' + this.props.search, JSON.stringify(search))

        this.key = Utils.getRandomNumber()

        this.cancelToken = {
            ...this.cancelToken || {},
            [this.key]: CancelToken.source()
        }
        this.setState({
            search: search,
            ...(options.dedupe && { dedupe: options.dedupe } || {}),
            data: [],
            dataSize: 0
        }, () => this.callSearch(this.key, options))
    }


    searchJson = () => {
        const search = this.state.search
        return Object.keys(search).filter(c => search[c] !== '' && search[c] !== null && search[c] !== undefined && ((Array.isArray(search[c]) && (search[c] || []).length > 0) || !Array.isArray(search[c]))).filter(champ => champ && champ[0] !== '?')
    }

    callSearch = async (key, options = {}) => {
        const search = EurestoClone(this.state.search, (k, v) => v === undefined ? null : v)
        const realSearch = this.searchJson()
        console.log(this.state.search, realSearch)
        if (realSearch.length > 0 || this.props.all || options.all) {
            Object.keys(this.cancelToken || {}).map(tokenKey => {
                console.log(this.key, key, tokenKey)
                if (tokenKey !== this.key) {
                    this.cancelToken[tokenKey].cancel('User disconnect')
                }
            })
            const groupBy = search && search["[[group_by]]"]
            delete search["[[group_by]]"]
            const defineOptions = search && search["[[options]]"]
            console.log('OPTION DEFINE', defineOptions)
            delete search["[[options]]"]
            const recherche = Utils.searchJsonToRechercheArray(search)
            let sorts = [];
            (this.state.sort || []).map(tri => {
                const champs = tri.id.split('/')
                sorts = sorts.concat(champs.map(champ => ({
                    champ: champ,
                    desc: tri.desc
                })))
            })
            const request = {
                requete: this.props.requete,
                action: 'list',
                ...(this.props.limit !== null ? {
                    limit: this.props.limit || 30,
                    offset: this.state.data && this.state.data.length || 0,
                } : {}),
                recherche: recherche,
                dedupe: this.state.dedupe,
                trie: sorts,
                group_by: this.props.group_by || groupBy && groupBy.split(',') || []
            }
            Bus.$emit('on_search_' + this.props.search, recherche)
            Object.keys(search).filter(champ => champ && champ[0] === '?').map(champ => {
                request[champ.substring(1, champ.length)] = search[champ]
            })
            const r = await ApiRequest(project.api + this.props.path, request, {
                showAlertError: false,
                cancelToken: this.cancelToken[key].token,
                ...defineOptions || {}
            })
            if (r && r.code === 1 && key === this.key) {
                const data = this.state.data && this.state.data.length === 0 && r.results || this.state.data.concat(r.results)
                const dataSize = this.props.limit === null && r.results.length
                    || this.state.data && this.state.data.length === 0 && r.length
                    || this.state.dataSize
                Bus.$emit('search_' + this.props.search,
                    {
                        data: data,
                        over: data.length >= dataSize,
                        sort: this.state.sort
                    })
                this.setState({
                    data: data,
                    dataSize: dataSize,
                    loading: false,
                    typingTimeout: 0,
                    cancelToken: {}
                })
                return
            }
        }
        if (key === this.key) {
            Bus.$emit('search_' + this.props.search, {
                data: [],
                over: false
            }
            )
            this.setState({
                loading: false,
                data: [],
                dataSize: 0,
                cancelToken: {}
            })
        }
    }

    clearSearch = _ => {
        const search = EurestoClone(this.props.defaultSearch) || {}
        this.setState({
            search: search,
            keyRAZ: Utils.getRandomNumber()
        }, () => this.search(search))
    }

    updateSearch = (data, rows = ['id']) => {
        const myData = this.state.data
        const index = (this.state.data || []).findIndex(d => rows.reduce((isFind, row) => isFind && d[row] === data[row], true))

        if (index !== -1) {
            myData[index] = data
            this.setState({
                data: myData,
            }, () => Bus.$emit('search_' + this.props.search,
                {
                    data: myData,
                    over: data.length >= this.state.dataSize,
                    sort: this.state.sort
                }))
        }
    }

    render() {

        return (
            <Grid key={this.state.keyRAZ} container
                style={{
                    margin: 0,
                    padding: 0,
                    height: '100%',
                    background: this.props.background || '#E9E9E9',
                    position: 'relative',
                    ...(this.props.mainStyle || {})
                }}
                spacing={0}
                className={'text-center'} justify={'flex-start'} direction={'column'} alignItems={'stretch'}>
                {this.props.raz && <i style={{
                    padding: 6,
                    borderRadius: '50%',
                    fontSize: 11,
                    textAlign: 'center',
                    right: 5,
                    position: 'absolute',
                    top: -27,
                    zIndex: 1
                }}
                    className={'ei-commun_fermer EurestoError EurestoText--text cursor-pointer'}
                    onClick={this.clearSearch} />}
                {this.props.children && {
                    ...this.props.children, props: {
                        ...this.props.children.props,
                        search: this.state.search,
                        dedupe: this.state.dedupe,
                        data: this.state.data,
                        searching: this.search,
                        defaultSearch: this.props.defaultSearch,
                        updateSearch: this.updateSearch
                    }
                }}
                <span style={this.props.style || { fontSize: 12, padding: 2, right: 32, position: 'absolute', top: -27 }}
                    className={'EurestoPrimary EurestoSecondary--text'}>{this.state.data.length}/{this.state.dataSize}</span>
            </Grid>
        )
    }

}

export default (Search)



// WEBPACK FOOTER //
// ./app/Components/Searching.js